import BaseApi from './BaseApi';
import { logError } from "../utils/errorLogger";

class ModelEconomiquePartenaireApi extends BaseApi {
  constructor() {
    super("model-economique-partenaire"); // Use BaseApi constructor with "model-economique-partenaire" endpoint
  }

  // Create a new model economique partenaire entry
  async createModelEconomiquePartenaire(data) {
    try {
      const response = await this.getApiInstance(true).post(`/${this.endpoint}`, data);
      return response.data;
    } catch (error) {
      logError(error);
      throw error;
    }
  }

  // Get all model economique partenaire entries
  async getAllModelEconomiquePartenaire() {
    try {
      const response = await this.getApiInstance(true).get(`/${this.endpoint}`);
      return response.data;
    } catch (error) {
      logError(error);
      throw error;
    }
  }

  // Get a single model economique partenaire entry by ID
  async getModelEconomiquePartenaireById(id) {
    try {
      const response = await this.getApiInstance(true).get(`/${this.endpoint}/${id}`);
      return response.data;
    } catch (error) {
      logError(error);
      throw error;
    }
  }

  // Update a model economique partenaire entry by ID
  async updateModelEconomiquePartenaire(id, data) {
    try {
      const response = await this.getApiInstance(true).put(`/${this.endpoint}/${id}`, data);
      return response.data;
    } catch (error) {
      logError(error);
      throw error;
    }
  }

  // Delete a model economique partenaire entry by ID
  async deleteModelEconomiquePartenaire(id) {
    try {
      const response = await this.getApiInstance(true).delete(`/${this.endpoint}/${id}`);
      return response.data;
    } catch (error) {
      logError(error);
      throw error;
    }
  }

  // Get model economique partenaire entries by partenaire ID
  async getModelEconomiquePartenaireByPartenaireId(partenaireId) {
    try {
      const response = await this.getApiInstance(true).get(`/${this.endpoint}/partenaire/${partenaireId}`);
      return response.data;
    } catch (error) {
      logError(error);
      throw error;
    }
  }

  // Get model economique partenaire entries by economic model ID
  async getModelEconomiquePartenaireByModelId(modelId) {
    try {
      const response = await this.getApiInstance(true).get(`/${this.endpoint}/model/${modelId}`);
      return response.data;
    } catch (error) {
      logError(error);
      throw error;
    }
  }

  // Get ordered payment methods for a partner
  async getOrderedPaymentMethods(partnerId) {
    try {
      const response = await this.getApiInstance(true).get(`/${this.endpoint}/partner/${partnerId}/ordered-payment-methods`);
      return response.data;
    } catch (error) {
      logError(error);
      throw error;
    }
  }

  // Get all B2C partenaires
  async getALLB2CPartenaires() {
    try {
      const response = await this.getApiInstance(true).get(`/${this.endpoint}/b2c`);
      return response.data;
    } catch (error) {
      logError(error);
      throw error;
    }
  }

  // Get all B2B clients with their payment methods
  async getB2CClients() {
    try {
      const response = await this.getApiInstance(true).get(`/${this.endpoint}/b2c-clients`);
      return response.data;
    } catch (error) {
      logError(error);
      throw error;
    }
  }

  // Get all B2C clients with their payment methods from new table
  async getB2CClientsWithPaymentMethods() {
    try {
      const response = await this.getApiInstance(true).get(`/${this.endpoint}/b2c-clients-new`);
      return response.data;
    } catch (error) {
      logError(error);
      throw error;
    }
  }

  // Update payment methods for a specific client
  async updateClientPaymentMethods(clientId, paymentMethods) {
    try {
      const response = await this.getApiInstance(true).put(`/${this.endpoint}/client/${clientId}/payment-methods`, {
        payment_method: paymentMethods
      });
      return response.data;
    } catch (error) {
      logError(error);
      throw error;
    }
  }

  // Create or update payment methods for a specific client (new table)
  async upsertClientPaymentMethods(clientId, paymentMethods) {
    try {
      console.log('API - clientId:', clientId);
      console.log('API - paymentMethods:', paymentMethods);
      console.log('API - paymentMethods type:', typeof paymentMethods);
      console.log('API - paymentMethods isArray:', Array.isArray(paymentMethods));
      
      const requestData = {
        payment_method: paymentMethods,
      };
      
      console.log('API - requestData:', requestData);
      
      const response = await this.getApiInstance(true).put(`/${this.endpoint}/client/${clientId}/payment-methods-new`, requestData);
      return response.data;
    } catch (error) {
      console.error('API - error:', error);
      logError(error);
      throw error;
    }
  }

  // Get distinct payment methods for a client
  async getClientPaymentMethods(clientId) {
    try {
      const response = await this.getApiInstance(true).get(`/${this.endpoint}/client/${clientId}/payment-methods`);
      return response.data;
    } catch (error) {
      logError(error);
      throw error;
    }
  }

  // Get payment methods for a specific client from new table
  async getClientPaymentMethodsFromNewTable(clientId) {
    try {
      const response = await this.getApiInstance(true).get(`/${this.endpoint}/client/${clientId}/payment-methods-new`);
      return response.data;
    } catch (error) {
      logError(error);
      throw error;
    }
  }

  // Delete payment methods for a specific client
  async deleteClientPaymentMethods(clientId) {
    try {
      const response = await this.getApiInstance(true).delete(`/${this.endpoint}/client/${clientId}/payment-methods`);
      return response.data;
    } catch (error) {
      logError(error);
      throw error;
    }
  }

  // Get economic models for a specific B2C client
  async getClientEconomicModels(clientId) {
    try {
      const response = await this.getApiInstance(true).get(`/${this.endpoint}/client/${clientId}/economic-models`);
      return response.data;
    } catch (error) {
      logError(error);
      throw error;
    }
  }

  // Get client segment (B2B or B2C)
  async getClientSegment(clientId) {
    try {
      const response = await this.getApiInstance(true).get(`/${this.endpoint}/client/${clientId}/segment`);
      return response.data;
    } catch (error) {
      logError(error);
      throw error;
    }
  }

  // Get intersection of user and client payment methods for B2C clients
  async getPaymentMethodsIntersection(clientId, userId) {
    try {
      const response = await this.getApiInstance(true).get(`/${this.endpoint}/client/${clientId}/payment-methods-intersection/${userId}`);
      return response.data;
    } catch (error) {
      logError(error);
      throw error;
    }
  }

  // Assign model to all B2C partners
  async assignModelToAllB2CPartners(modelId) {
    try {
      const response = await this.getApiInstance(true).post(`/${this.endpoint}/assign-all-b2c`, {
        modelId
      });
      return response.data;
    } catch (error) {
      logError(error);
      throw error;
    }
  }

  // Get valid economic models for booking based on dates and partner
  async getValidEconomicModelsForBooking(partnerId, checkInDate, checkOutDate) {
    try {
      const response = await this.getApiInstance(true).get(`/${this.endpoint}/booking/create/valid-economic-models`, {
        params: {
          partnerId,
          checkInDate,
          checkOutDate
        }
      });
      return response.data;
    } catch (error) {
      logError(error);
      throw error;
    }
  }
}

export default new ModelEconomiquePartenaireApi();
